/** C-04 고객 진행 내역 화면에서만 사용하는 비식별 정적 Mock 데이터입니다. */
export const legacyProgressColumns = [
  'NO', '고객번호', '(old)', '계약일자', '아기', '엄마', '휴대폰', '계약번호',
  '계약상품명', '상세상품명', '촬영일', '업로드', '다운로드', '고객선택', '편집완료', '최종컨펌', '출고일',
] as const

export const legacyProgressColumnWidths = [
  31.078125, 69.65625, 39.796875, 78.09375, 41.71875, 52.078125, 100.9375,
  54.875, 181.21875, 191.0625, 44.125, 44.125, 54.484375, 54.484375,
  54.484375, 54.484375, 44.125,
]

export type LegacyProgressRow = {
  no: number
  customerNo: string
  oldCustomerNo: string
  contractDate: string
  baby: string
  parent: string
  phone: string
  contractNo: string
  packageName: string
  detailPackageName: string
  shootDate: string
  uploaded: string
  downloaded: string
  customerSelected: string
  editDone: string
  confirmed: string
  delivered: string
}

/** 원본 기본 상태의 136개 물리 행 높이를 재현하기 위한 Mock 목록입니다. */
export const legacyProgressRows: LegacyProgressRow[] = Array.from({ length: 136 }, (_, index) => {
  const sequence = index + 1
  const day = String((index % 28) + 1).padStart(2, '0')
  return {
    no: sequence,
    customerNo: `C-PRG-${String(sequence).padStart(3, '0')}`,
    oldCustomerNo: '-',
    contractDate: `2026-08-${day}`,
    baby: `아기 ${sequence}`,
    parent: `고객 ${sequence}`,
    phone: `010-0000-${String(sequence).padStart(4, '0')}`,
    contractNo: `CT-${String(sequence).padStart(4, '0')}`,
    packageName: 'Mock 성장 패키지',
    detailPackageName: 'Mock 기본 구성',
    shootDate: `2026-09-${day}`,
    uploaded: index % 3 === 0 ? '완료' : '-',
    downloaded: index % 4 === 0 ? '완료' : '-',
    customerSelected: index % 5 === 0 ? '완료' : '-',
    editDone: index % 2 === 0 ? '완료' : '-',
    confirmed: index % 3 === 0 ? '완료' : '-',
    delivered: index % 6 === 0 ? '완료' : '-',
  }
})

export const legacyProgressOptions = {
  offices: Array.from({ length: 38 }, (_, index) => `Mock 지점 ${String(index + 1).padStart(2, '0')}`),
  packages: Array.from({ length: 58 }, (_, index) => `Mock 패키지 ${String(index + 1).padStart(2, '0')}`),
  pageLimits: ['30', '60', '100', '500', '1000'],
  completed: ['미지정', '고객선택충족', '고객이 사진 선택(업로드)', '편집본 업로드', '편집본 승인', '출고완료'],
  incomplete: ['촬영 원본 미업로드', '고객이 사진 미선택(업로드)', '편집본 미업로드', '편집본 미승인', '미출고'],
}
